// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_categories.scss
// module id = 35
// module chunks = 0